import { useTranslation } from 'react-i18next';
import { useUntrackedInboundCallsFilters } from 'infrastructure/hooks/untrackedInboundCalls/useFilters';

import s from './styles.module.scss';
import DateRange from './date-range';
import Input from './input';

import type { ReactNode, FC } from 'react';
import type { AppendFilters } from 'infrastructure/hooks/untrackedInboundCalls/types';

const Wrapper: FC<{ children: ReactNode }> = ({ children }) => {
  return <div className={s['filter-wrapper']}>{children}</div>;
};

const Body: FC = () => {
  const { t } = useTranslation();

  const { updateFilter, filter } = useUntrackedInboundCallsFilters();

  const appendFiltersAndResetPage: AppendFilters = (newFilter) => {
    updateFilter({ page: undefined, ...newFilter });
  };

  return (
    <div className={s.wrapper}>
      <Wrapper>
        <DateRange filters={filter} appendFilters={appendFiltersAndResetPage} />
      </Wrapper>
      <Wrapper>
        <Input
          value={filter.agent}
          onChange={(value) => {
            appendFiltersAndResetPage({ agent: value });
          }}
          label={t('labels.agent')}
          id="search-by-agent-email"
          placeholder={t('placeholders.searchByAgentEmail')}
        />
      </Wrapper>
      <Wrapper>
        <Input
          value={filter.callId}
          onChange={(value) => {
            appendFiltersAndResetPage({ callId: value });
          }}
          label={t('labels.callId')}
          id="search-by-call-id"
          placeholder={t('placeholders.searchByCallId')}
        />
      </Wrapper>
      <Wrapper>
        <Input
          value={filter.phone}
          onChange={(value) => {
            appendFiltersAndResetPage({ phone: value });
          }}
          label={t('labels.sourcePhone')}
          id="search-by-source-phone"
          placeholder={t('placeholders.searchByPhone')}
        />
      </Wrapper>
    </div>
  );
};

export default Body;
